import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { CommonModule, NgIf } from '@angular/common';
import { Router } from '@angular/router';
import { AuthService } from '../../../services/auth.service';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, NgIf, MatIconModule, MatTooltipModule],
  templateUrl: './app-header.component.html',
  styleUrl: './app-header.component.css'
})
export class AppHeaderComponent implements OnInit {
  userName = 'DemoUser';
  isAdminPage = false;
  isAdminUser = false;

  @Output() logoutEvent = new EventEmitter<void>();
  @Output() settingsEvent = new EventEmitter<void>();
  @Input() isAdmin: boolean = false;

  constructor(private authService: AuthService, private router: Router) {}

  ngOnInit(): void {
    // Get user information from localStorage if available
    const storedUser = localStorage.getItem('googleUser');
    if (storedUser) {
      const user = JSON.parse(storedUser);
      if (user.name.length >= 25) {
        this.userName = user.name.split(' ')[0] || 'User';
      } else {
        this.userName = user.name || 'User';
      }
    } else {
      this.userName = 'User'; // Default if no user info is found
    }

    // Check if we're on the admin page
    this.isAdminPage = this.router.url.includes('/admin');

    // Check if user has admin role
    const userRole = localStorage.getItem('userRole');
    this.isAdminUser = userRole === 'admin';
  }

  logout() {
    console.log('logout clicked');
    this.authService.logout();
    this.router.navigate(['/']);
  }

  /**
   * Navigate between admin and app routes using programmatic navigation
   */
  navigateToggle(event: Event): void {
    event.preventDefault();
    const targetRoute = this.isAdminPage ? '/app' : '/admin';
    console.log('🔄 Navigating to:', targetRoute);
    this.router.navigate([targetRoute]);
  }

  onSettingsClick() {
    console.log('Settings clicked');
    // Emit event to notify parent component
    this.settingsEvent.emit();
    // For now, this button doesn't do anything else
  }
}
